// components/FormBuilder/AddContent.tsx

import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import { PlusOutlined, MenuOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { Space } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { Popover } from 'antd';

const { Text } = Typography;

const AddContent = ({ onAdd }) => {
    const menu = (
        <Menu>
            <Menu.SubMenu
                key="text"
                title={
                    <Space align="center">
                        <FeatherIcon icon="type" size={14} />
                        <Text>Text</Text>
                    </Space>
                }
            >
                <Menu.Item key="large-heading" onClick={() => onAdd('TextHeading')}>
                    Large Heading
                </Menu.Item>
                <Menu.Item key="small-heading" onClick={() => onAdd('TextSubheading')}>
                    Small Heading
                </Menu.Item>
                <Menu.Item key="body" onClick={() => onAdd('TextBody')}>
                    Body
                </Menu.Item>
                <Menu.Item key="caption" onClick={() => onAdd('TextCaption')}>
                    Caption
                </Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu
                key={'text-answer'}
                title={
                    <Space align="center">
                        <FeatherIcon icon="edit" size={14} />
                        <Text>Text Answer</Text>
                    </Space>
                }
            >
                <Menu.Item key="text-input" onClick={() => onAdd('TextInput')}>
                    Short Text
                </Menu.Item>
                <Menu.Item key="text-area" onClick={() => onAdd('TextArea')}>
                    Paragraph
                </Menu.Item>
                <Menu.Item key="date-picker" onClick={() => onAdd('DatePicker')}>
                    Date Picker
                </Menu.Item>
            </Menu.SubMenu>
            <Menu.SubMenu
                key="selection"
                title={
                    <Space align="center">
                        <FeatherIcon icon="menu" size={14} />
                        <Text>Selection</Text>
                    </Space>
                }
            >
                <Menu.Item key="single-choice" onClick={() => onAdd('RadioButtonsGroup')}>
                    <Text>Single Choice</Text>
                </Menu.Item>

                <Menu.Item key="multiple-choice" onClick={() => onAdd('CheckboxGroup')}>
                    <Text>Multiple Choice</Text>
                </Menu.Item>

                <Menu.Item key="dropdown" onClick={() => onAdd('Dropdown')}>
                    <Text>Dropdown</Text>
                </Menu.Item>
                <Menu.Item key="opt-in" onClick={() => onAdd('OptIn')}>
                    <Text>Opt-In</Text>
                </Menu.Item>
            </Menu.SubMenu>

            <Menu.SubMenu
                key="media"
                title={
                    <Space align="center">
                        <FeatherIcon icon="image" size={14} />
                        <Text>Media</Text>
                    </Space>
                }
            >
                <Menu.Item key="image" onClick={() => onAdd('Image')}>
                    Image
                </Menu.Item>
            </Menu.SubMenu>
        </Menu>
    );

    return (
        <Popover trigger={['click']} content={menu}>
            <Button
                icon={<PlusOutlined />}
                type="dashed"
                style={{
                    width: 'fit-content',
                    margin: '1rem 0',
                }}
            >
                Add Content
            </Button>
        </Popover>
    );
};

export default AddContent;
